import {Globals} from "root/DataFunctions/BaseDataFns";
import {ImagePath} from "root/DataFunctions/Constants";

export const getDocumentUrl = (document_id, size, square, attachment_id) => {

    let url = '';

    const localSize = size === null || size === undefined ? 400 : size ;
    const localSquare = square === null || square ? false : square ;

    if (document_id === null || document_id === undefined)
    {
        if (attachment_id === null || attachment_id === undefined)
        {
            url = ImagePath.IMAGE_NO_IMAGE;
        }
        else
        {
            url = ImagePath.IMAGE_POST_DOC;
        }
    }
    else
    {
        url = Globals.APIFolder + '/images/' + document_id + '?size=' + localSize + '&square=' + localSquare;
    }

    return url;
}

export const getUserImageUrl = (document_id, size, square) =>
{
    const localSize = size === null || size === undefined ? 400 : size ;
    const localSquare = square === null || square ? false : square ;

    if (document_id === null || document_id === undefined)
    {
        return ImagePath.IMAGE_DEFAULT_PERSON;
    }
    else
    {
        return Globals.APIFolder + '/images/' + document_id + '?size=' + localSize + '&square=' + localSquare;
    }
}